'use strict';

// Maps languages to their most popular countries (some languages may not be mapped).
// Generated by queries like "English LanguageData LargestCountry CountryCode" in http://www.wolframalpha.com/
//
// List of relevant languages is based on:
// _(locales).groupBy((locale) => { return locale.substr(0, 2) }).toPairs().filter((pairs) => { return (pairs[1].length > 1) }).map((pairs) => { return pairs[0] }).value()

Object.defineProperty(exports, "__esModule", {
	value: true
});
var largestCountries = exports.largestCountries = {
	'af': 'ZA',
	'ar': 'EG',
	'bn': 'BD',
	'bo': 'CN',
	'ca': 'ES',
	'da': 'DK',
	'de': 'DE',
	'ee': 'GH',
	'el': 'GR',
	'en': 'US',
	'es': 'MX',
	'fa': 'IR',
	'ff': 'MR',
	'fo': 'DK',
	'fr': 'FR',
	'ha': 'NG',
	'hr': 'HR',
	'it': 'IT',
	'ko': 'KR',
	'ln': 'CD',
	'ms': 'MY',
	'nb': 'NO',
	'ne': 'NP',
	'nl': 'NL',
	'om': 'ET',
	'os': 'GE',
	'pa': 'IN',
	'pt': 'BR',
	'qu': 'PE',
	'ro': 'RO',
	'ru': 'RU',
	'se': 'NO',
	'so': 'SO',
	'sq': 'AL',
	'sr': 'RS',
	'sv': 'SE',
	'sw': 'TZ',
	'ta': 'IN',
	'ti': 'ET',
	'tr': 'TR',
	'ur': 'IN',
	'uz': 'UZ',
	'yo': 'NG',
	'zh': 'CN'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/locale-helpers/dist/Languages.js
// module id = 866
// module chunks = 0